module.exports = __webpack_public_path__ + "static/media/997142.d78b1f36.png";